import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { BrandButton } from "@/components/PageHeader";
import { api, errMsg, shortId } from "@/lib/api";

export const TypesDialog = ({ open, onClose }) => {
  const [types, setTypes] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) { api.get("/special-receipts/types").then((r) => setTypes(r.data)); }
  }, [open]);
  const update = (id, patch) => setTypes((ts) => ts.map((t) => (t.id === id ? { ...t, ...patch } : t)));
  const save = async () => {
    if (types.some((t) => t.name.trim().length < 2)) return toast.error("Every payment type needs a name");
    setBusy(true);
    try {
      await api.put("/special-receipts/types", { types });
      toast.success("Payment types saved");
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl" data-testid="special-types-dialog">
        <DialogHeader><DialogTitle className="font-heading">Payment types</DialogTitle></DialogHeader>
        <p className="text-sm text-gray-500 -mt-2">Preset descriptions staff can pick when creating a special receipt. The default amount is filled in automatically and can still be changed (0 = no default).</p>
        <div className="space-y-2">
          <div className="hidden sm:grid grid-cols-[1fr_140px_40px] gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-500"><span>Name</span><span>Default (GH₵)</span><span /></div>
          {types.map((t, i) => (
            <div key={t.id} className="grid grid-cols-[1fr_110px_40px] sm:grid-cols-[1fr_140px_40px] gap-2" data-testid={`special-type-row-${i}`}>
              <Input value={t.name} onChange={(e) => update(t.id, { name: e.target.value })} data-testid={`special-type-name-${i}`} />
              <Input type="number" min="0" value={t.default_amount} onChange={(e) => update(t.id, { default_amount: Number(e.target.value) || 0 })} className="font-mono" data-testid={`special-type-amount-${i}`} />
              <button type="button" onClick={() => setTypes((ts) => ts.filter((x) => x.id !== t.id))} className="w-10 h-10 grid place-items-center rounded-md text-gray-500 hover:text-[#E60000] hover:bg-[#FFF0F0]" aria-label="Remove" data-testid={`special-type-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap justify-between gap-2 mt-2">
          <BrandButton variant="outline" onClick={() => setTypes((ts) => [...ts, { id: shortId(), name: "", default_amount: 0 }])} data-testid="special-type-add"><Plus className="w-4 h-4" />Add type</BrandButton>
          <BrandButton onClick={save} disabled={busy} data-testid="special-types-save">{busy ? "Saving…" : "Save types"}</BrandButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
